import * as firebase from 'firebase';


// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
    apiKey: "AIzaSyAHq-oK_1FG6axsUo5RqgrnLZ8KW9PM-x4",
    authDomain: "walid-delevery.firebaseapp.com",
    databaseURL: "https://walid-delevery.firebaseio.com",
    projectId: "walid-delevery",
    storageBucket: "walid-delevery.appspot.com",
    messagingSenderId: "295338975163",
    appId: "1:295338975163:web:9f8aab5d6b4af47e8eae9e",
    measurementId: "G-NQ9CDJ4DQL"
  };
  //Initialize Firebase 
  firebase.initializeApp(firebaseConfig);

  export default firebase;